import {
	faIslandTropical,
	faLocationDot,
	faRightToBracket,
} from '@fortawesome/pro-regular-svg-icons';
import { authenticate } from '@uturn/api';
import { useDevTools } from '../devtools';
import { CommandPaletteAction, LoginProfiles } from './types';

export function useDevActions() {
	if (!import.meta.env.DEV) {
		return { actions: [] };
	}

	// TODO: Use zod to parse env variable
	const profiles: LoginProfiles = JSON.parse(
		import.meta.env.VITE_LOGIN_PROFILES ?? '[]',
	) as unknown as LoginProfiles;

	const actions: CommandPaletteAction[] = Object.keys(profiles).map((key) => ({
		name: `Login with ${key}`,
		icon: faRightToBracket,
		onAction: () => {
			authenticate({
				username: profiles[key].email,
				password: profiles[key].password,
			}).then((token) => {
				window.location.href = '/shipments';
			});
		},
	}));

	actions.push(
		...[
			{
				icon: faIslandTropical,
				name: 'Toggle Tanstack Query Dev Tools',
				onAction: () => {
					useDevTools.getState().toggleTanstackQueryDevTools();
				},
			},
			{
				icon: faLocationDot,
				name: 'Toggle Tanstack Router Dev Tools',
				onAction: () => {
					useDevTools.getState().toggleTanstackRouterDevTools();
				},
			},
		],
	);

	return { actions };
}
